import { FC } from 'react';
import { Icon } from '@kontentino/ui';
import { PageNumberType, TYPE } from '@kontentino/kontentino-constants/Pages';
import { faFacebook } from '@fortawesome/free-brands-svg-icons/faFacebook';
import { faInstagram } from '@fortawesome/free-brands-svg-icons/faInstagram';
import { faLinkedin } from '@fortawesome/free-brands-svg-icons/faLinkedin';
import { faXTwitter } from '@fortawesome/free-brands-svg-icons/faXTwitter';
import { faPinterest } from '@fortawesome/free-brands-svg-icons/faPinterest';
import { faYoutube } from '@fortawesome/free-brands-svg-icons/faYoutube';
import { faTiktok } from '@fortawesome/free-brands-svg-icons/faTiktok';
import { faThreads } from '@fortawesome/free-brands-svg-icons/faThreads';
import { faGoogle } from '@fortawesome/free-brands-svg-icons/faGoogle';
import { IconDefinition } from '@fortawesome/fontawesome-svg-core';

export type CharacterCounterCountConfig = {
  characters: number;
  hashtags: number;
  mentions: number;
};

const PAGE_TYPE_ICON: Partial<Record<PageNumberType, IconDefinition>> = {
  [TYPE.FACEBOOK]: faFacebook,
  [TYPE.FACEBOOK_AD]: faFacebook,
  [TYPE.INSTAGRAM]: faInstagram,
  [TYPE.LINKEDIN]: faLinkedin,
  [TYPE.TWITTER]: faXTwitter,
  [TYPE.PINTEREST]: faPinterest,
  [TYPE.YOUTUBE]: faYoutube,
  [TYPE.TIKTOK]: faTiktok,
  [TYPE.THREADS]: faThreads,
  [TYPE.GOOGLE_MY_BUSINESS]: faGoogle,
};

type Props = {
  limit?: number;
  count: CharacterCounterCountConfig;
  pageType?: PageNumberType;
};

const CharacterCounter: FC<Props> = ({ limit, count, pageType }) => {
  const {
    characters: charCount,
    hashtags: hashtagsCount,
    mentions: mentionsCount,
  } = count;

  if (charCount === 0 && hashtagsCount === 0 && mentionsCount === 0) {
    return null;
  }

  const socialIcon = pageType ? PAGE_TYPE_ICON[pageType] : undefined;

  const renderIcon = () =>
    socialIcon ? (
      <Icon icon={socialIcon} size="sm" className="tw-text-grayscale-100" />
    ) : null;

  if (typeof limit === 'number') {
    return (
      <div className="tw-ml-auto tw-flex tw-items-center tw-gap-1 tw-text-xs tw-text-grayscale-100">
        {renderIcon()}
        <span>
          {`${charCount}/${limit}`}
          {hashtagsCount > 0 && `, #${hashtagsCount}`}
          {mentionsCount > 0 && `, @${mentionsCount}`}
        </span>
      </div>
    );
  }

  return (
    <div className="tw-ml-auto tw-flex tw-items-center tw-gap-1 tw-text-xs tw-text-grayscale-100">
      {renderIcon()}
      <span>
        {charCount}
        {hashtagsCount > 0 && `, #${hashtagsCount}`}
        {mentionsCount > 0 && `, @${mentionsCount}`}
      </span>
    </div>
  );
};

export default CharacterCounter;
